import React from "react";
import { useNavigate } from "react-router";
import useAuth from "../providers/authProvider";


export function HomePage() {
  const { role } = useAuth();

  let navigate = useNavigate();
  const routeChange = (path: string) => {
    navigate(path);
  }

  return (<>
    <div className="vtmn-flex vtmn-justify-center vtmn-items-center" style={{ height: 'calc(100vh / 2 )' }}>
    { ['READER', 'ADMIN'].indexOf(role) !== -1 && <div className="block vtmn-m-5" style={{ width: '300px' }}>
        <div className="vtmn-card vtmn-card_variant--top-image vtmn-items-center hover:vtmn-opacity-50 vtmn-cursor-pointer vtmn-overflow-hidden" style={{ width: '70%', height: '70%', margin: 'auto' }} onClick={() => routeChange('/invoice')}>
          <div><span style={{ fontSize: '60px', margin: '50px' }} className="vtmx-file-line" aria-hidden="true"></span></div>
          <div className="vtmn-card_content vtmn-items-center vtmn-z-10">
            <h2 className="vtmn-card_content--title vtmn-z-10">Invoice</h2>
          </div>
          <div className="diagonale" />
        </div>
      </div> }
      { ['ADMIN'].indexOf(role) !== -1 && <div className="block vtmn-m-5" style={{ width: '300px' }}>
        <div className="vtmn-card vtmn-card_variant--top-image vtmn-items-center hover:vtmn-opacity-50 vtmn-cursor-pointer vtmn-overflow-hidden" style={{ width: '70%', height: '70%', margin: 'auto' }} onClick={() => routeChange('/escrow')}>
          <div><span style={{ fontSize: '60px', margin: '50px' }} className="vtmx-file-fill" aria-hidden="true"></span></div>
          <div className="vtmn-card_content vtmn-items-center vtmn-z-10">
            <h2 className="vtmn-card_content--title vtmn-z-10">Escrow</h2>
          </div>
          <div className="diagonale" />
        </div>
      </div> }
      { ['READER', 'ADMIN'].indexOf(role) !== -1 && <div className="block vtmn-m-5" style={{ width: '300px' }}>
        <div className="vtmn-card vtmn-card_variant--top-image vtmn-items-center hover:vtmn-opacity-50 vtmn-cursor-pointer vtmn-overflow-hidden" style={{ width: '70%', height: '70%', margin: 'auto' }} onClick={() => routeChange('/commission')}>
          <div><span style={{ fontSize: '60px', margin: '50px' }} className="vtmx-money-euro-box-line" aria-hidden="true"></span></div>
          <div className="vtmn-card_content vtmn-items-center vtmn-z-10">
            <h2 className="vtmn-card_content--title vtmn-z-10">Commission</h2>
          </div>
          <div className="diagonale" />
        </div>
      </div> }
    </div>
    <div className="vtmn-flex vtmn-justify-center vtmn-items-center">
      { ['READER', 'ADMIN'].indexOf(role) !== -1 && <div className="block vtmn-m-5" style={{ width: '300px' }}>
        <div className="vtmn-card vtmn-card_variant--top-image vtmn-items-center hover:vtmn-opacity-50 vtmn-cursor-pointer vtmn-overflow-hidden" style={{ width: '70%', height: '70%', margin: 'auto' }} onClick={() => routeChange('/producer')}>
          <div><span style={{ fontSize: '60px', margin: '50px' }} className="vtmx-user-line" aria-hidden="true"></span></div>
          <div className="vtmn-card_content vtmn-items-center vtmn-z-10">
            <h2 className="vtmn-card_content--title vtmn-z-10">Producer</h2>
          </div>
          <div className="diagonale" />
        </div>
      </div> }
      { ['ADMIN'].indexOf(role) !== -1 && <div className="block vtmn-m-5" style={{ width: '300px' }}>
        <div className="vtmn-card vtmn-card_variant--top-image vtmn-items-center hover:vtmn-opacity-50 vtmn-cursor-pointer vtmn-overflow-hidden" style={{ width: '70%', height: '70%', margin: 'auto' }} onClick={() => routeChange('/business')}>
          <div><span style={{ fontSize: '60px', margin: '50px' }} className="vtmx-line-chart-line" aria-hidden="true"></span></div>
          <div className="vtmn-card_content vtmn-items-center vtmn-z-10">
            <h2 className="vtmn-card_content--title vtmn-z-10">Business</h2>
          </div>
          <div className="diagonale" />
        </div>
      </div> }
      { ['ADMIN'].indexOf(role) !== -1 && <div className="block vtmn-m-5" style={{ width: '300px' }}>
        <div className="vtmn-card vtmn-card_variant--top-image vtmn-items-center hover:vtmn-opacity-50 vtmn-cursor-pointer vtmn-overflow-hidden" style={{ width: '70%', height: '70%', margin: 'auto' }} onClick={() => routeChange('/user')}>
          <div><span style={{ fontSize: '60px', margin: '50px' }} className="vtmx-group-line" aria-hidden="true"></span></div>
          <div className="vtmn-card_content vtmn-items-center vtmn-z-10">
            <h2 className="vtmn-card_content--title vtmn-z-30">User</h2>
          </div>
          <div className="diagonale" />
        </div>
      </div>}
    </div>
  </>

  )
}